import { getIcon } from './utils/getIcon';
export const getSocialLinks = (themeName) => [
    {
        label: 'Telegram',
        href: 'https://t.me/AlphaFiSUI',
        icon: themeName === 'dark' ? getIcon('whiteTelegramIcon') : getIcon('darkThemeTelegram'),
    },
    {
        label: 'Twitter',
        href: 'https://x.com/AlphaFiSUI',
        icon: themeName === 'dark' ? getIcon('whiteTwitter') : getIcon('darkThemeTwitter'),
    },
    {
        label: 'Medium',
        href: 'https://alphafisui.medium.com/',
        icon: themeName === 'dark' ? getIcon('WhiteMediumIcon') : getIcon('darkThemeMedium'),
    },
];
export const AUDIT_LINKS = [
    {
        label: 'Audited by Movebit',
        href: 'https://movebit.xyz/',
    },
    {
        label: 'Secured by zeroShadow',
        href: 'https://www.zeroshadow.io/',
    },
];
export const DOCS_LINKS = [
    { label: 'Analytics', href: '/analytics' },
    { label: 'Docs', href: 'https://docs.alphafi.xyz/' },
];
export const getFooterLinks = (themeName) => ({
    auditLinks: AUDIT_LINKS,
    docsLinks: DOCS_LINKS,
    socialLinks: getSocialLinks(themeName),
});
export const getNavLinks = (themeName) => [
    {
        name: 'App',
        href: '/',
    },
    // {
    //   name: 'Airdrop',
    //   href: '/airdrop',
    // },
    // {
    //   name: 'Markets',
    //   href: '/markets',
    // },
    {
        name: 'ALPHA',
        href: '/alpha',
    },
    {
        name: 'stSUI',
        href: 'https://stsui.com',
        icon: themeName === 'dark' ? getIcon('whiteExternalLinkIcon') : getIcon('blackExternalLinkIcon'),
        isExternal: true,
    },
    {
        name: 'AlphaLend',
        href: 'https://alphalend.xyz',
        isExternal: true,
        icon: themeName === 'dark' ? getIcon('whiteExternalLinkIcon') : getIcon('blackExternalLinkIcon'),
    },
    {
        name: 'More',
        href: '',
        icon: themeName === 'dark' ? getIcon('darkThemeDownArrow') : getIcon('downArrowBlack'),
        subLinks: [
            {
                name: 'Analytics',
                href: '/analytics',
                isExternal: false,
            },
            // {
            //   name: 'VOTE',
            //   href: '/vote',
            //   isExternal: false,
            // },
            {
                name: 'Cetus compensation',
                href: '/cetus-compensation',
                isExternal: false,
            },
        ],
    },
];
// For backward compatibility, export the default dark theme version
export const NAV_LINKS = getNavLinks('dark');
